// @flow
import * as React from 'react';
import Swipe from 'react-easy-swipe';
import Waypoint from 'react-waypoint';
import _ from 'lodash';
import { connect } from 'react-redux';
import { setLandingScrollPosition } from '../../redux/actionCreators';

type Props = {
  id: string,
  children?: React.Node,
  mobile: boolean,
  height: number,
  handleLandingScrollPositionUpdate: (landingScrollPosition: string) => void,
  handleScroll: (direction: number) => void,
  handleWheelMove: (e: SyntheticWheelEvent<>) => void,
};

type State = {
  mobile: boolean,
  height: number,
};

class Slide extends React.Component<Props, State> {
  handleLandingScrollPositionUpdate = (landingScrollPosition: string): void =>
    this.props.handleLandingScrollPositionUpdate(landingScrollPosition);

  onSwipeMove = _.debounce(
    position => {
      if (position.y > 0) {
        this.props.handleScroll(-1);
      } else {
        this.props.handleScroll(1);
      }
    },
    80,
    { leading: true, trailing: false },
  );

  render() {
    const { id, children } = this.props;

    return (
      <Swipe onSwipeMove={this.onSwipeMove}>
        <div id={id} onWheel={e => this.props.handleWheelMove(e.deltaY)}>
          <Waypoint onEnter={() => this.handleLandingScrollPositionUpdate(id)} />
          {children}
        </div>
      </Swipe>
    );
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = (dispatch: Function) => ({
  handleLandingScrollPositionUpdate(landingScrollPosition) {
    dispatch(setLandingScrollPosition(landingScrollPosition));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Slide);



// WEBPACK FOOTER //
// ./src/components/Landing/Slide.js